import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppServiceService } from '../../api/app-service.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {

  notifications: any = [];

  constructor(public appService: AppServiceService, public router: Router) { }

  ngOnInit() {
    // dummy data
    // for (let i = 0; i < 10; i++) {
    //   this.notifications.push({
    //     title: 'This is the title',
    //     message: 'This is the message content as a string value to display',
    //     receivedDate: '10 Jun 2021',
    //     didRead: i < 2 ? false : true
    //   });
    // }
    this.appService.appObject.notifications = [];
    this.appService.fetchNotifications();
  }

  /**
   * Will trigger when user click on a notification
   * @param notification selected notification
   */
  readNotification(notification) {
    if (notification.status !== 'false') {
      this.appService.selectedNotification = notification;
      // navigate to notification content
      this.router.navigate(['notification']);
    } else {
      this.appService.markNotificationAsRead(notification).then((response) => {
        notification.status = 'true';
        this.appService.selectedNotification = notification;
        this.router.navigate(['notification']);
      }).catch((error) => {
        console.log('error');
      });
    }
  }

}
